<template>

<div class="sale">

    <div class="sale-total" v-tooltip="'Total amount'">{{ item.total | formatMoney }}</div>
    <div class="sale-discount" v-if="item.discount" v-tooltip="'Discount code'">{{ item.discount.code }}</div>

</div>

</template>

<script>

export default {

	props: ['item']

}

</script>

<style scoped>

.sale {
    
}

.sale-total {
	line-height: 16px;
	font-weight: 400;
    font-size: 12px;
	border-radius: 4px;
    padding: 0px 4px;
    margin-top: 2px;
	background-color: #999;
    display: inline-block;
    color: #fff;
}

.sale-discount {
	line-height: 16px;
	font-weight: 400;
    font-size: 12px;
	border-radius: 4px;
    padding: 0px 4px;
    margin-top: 2px;
	background-color: #316bb3;
    display: inline-block;
    text-transform: uppercase;
    color: #fff;
    margin-left: 4px;
}

</style>
